// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__fLh5E","productName":"Table_productName__fGYVF"};